<template>
  <div
    v-if="manifest"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-card-title>
          <span style="color: #0074BA">回収報告/運搬完了報告</span>&emsp;
        </v-card-title>
        <v-card
          flat
          class="rounded-card"
          v-for="manifest_transport in manifest.collection_manifest_transports"
          :key="manifest_transport.section"
        >
          <v-card-text>
            <v-card-subtitle class="subtitle-1 font-weight-bold">区間{{ manifest_transport.section }}</v-card-subtitle>
            <!-- 報告日時/荷姿の数量/運搬量/運搬量の単位 -->
            <v-row>
              <v-col cols="12" md="3">
                <div class="overline">
                  報告日時
                </div>
                <h4>
                  {{ manifest_transport.transport_complete_report.transport_completed_at | unix_datetime_format }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3" v-if="isAllocate">
                <div class="overline">
                  荷姿の数量
                </div>
                <h4>
                  {{ manifest_transport.transport_complete_report.app_transport_packing_quantity || '-' }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3">
                <div class="overline">
                  運搬量
                </div>
                <h4>
                  {{ manifest_transport.transport_complete_report.app_transport_quantity || '-' }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3">
                <div class="overline">
                  運搬量の単位
                </div>
                <h4>
                  {{ manifest_transport.transport_complete_report.app_transport_quantity_unit_name || '-' }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TransportReportResult',
  components: {},
  mixins: [],
  props: {
    manifest: {
      type: Object,
      default: () => null
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isAllocate: 'use_allocate',
    }),
  },
  watch: {},
  created() {
  },
  methods: {
  }
}
</script>
